import { FailureClassification } from './types';

const getErrorCode = (error: any): string => {
  if (typeof error?.code === 'string' && error.code.trim()) {
    return error.code.toLowerCase();
  }
  if (typeof error?.name === 'string' && error.name.trim()) {
    return error.name.toLowerCase();
  }
  return 'unknown_error';
};

const getHttpStatus = (error: any): number | undefined => {
  if (typeof error?.statusCode === 'number') return error.statusCode;
  if (typeof error?.status === 'number') return error.status;
  if (typeof error?.response?.status === 'number') return error.response.status;
  return undefined;
};

export const createFailureClassification = (operation: string, error: unknown): FailureClassification => {
  const parsedError = error as any;
  const http_status = getHttpStatus(parsedError);

  return {
    operation,
    http_status,
    error_code: getErrorCode(parsedError),
    retryable: !http_status || http_status >= 500,
  };
};

export const mapApiErrorToTelemetry = (operation: string, error: unknown): Record<string, unknown> => {
  const failure = createFailureClassification(operation, error);
  return {
    operation: failure.operation,
    http_status: failure.http_status,
    error_code: failure.error_code,
    retryable: failure.retryable,
  };
};
